import { render, staticRenderFns } from "./TrangQuanLyThongTinNguoiDung.vue?vue&type=template&id=fc77e84c&"
import script from "./TrangQuanLyThongTinNguoiDung.vue?vue&type=script&lang=js&"
export * from "./TrangQuanLyThongTinNguoiDung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports